/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/components/ToolRecommendationOptionalStep.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useLocation, useParams } from 'quartz-routing/react-router';
import { useCallback, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Box } from 'foundations-components/transitional/components/Box';
import { HR } from 'foundations-components/transitional/components/HR';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { View } from 'foundations-components/transitional/components/View';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { FullWidthHighlight } from 'academy-common-lib/components/navigation/contentNavigator/LessonNavigatorAsset';
import UsageTracker from '../../../utils/UsageTracker';
import { useGetToolRecommendations } from '../hooks/softwareDiscoveryHooks.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ToolRecommendationOptionalStep = ({
  contentLanguage,
  to,
  useCases
}) => {
  const {
    trackId,
    lessonId,
    contentId
  } = useParams();
  const location = useLocation();
  const toolRecommendations = useGetToolRecommendations(useCases, contentLanguage);
  const trackOptionalRecommendationStepClick = useCallback(() => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'optional-recommendation-step-clicked',
      trackId,
      lessonId
    });
  }, [lessonId, trackId]);
  useEffect(() => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'optional-recommendation-step-rendered',
      trackId,
      lessonId
    });
  }, [lessonId, trackId]);
  if (!toolRecommendations) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "xs"
      })
    }), /*#__PURE__*/_jsx(ACRouterLink, {
      onClick: trackOptionalRecommendationStepClick,
      to: typeof to === 'string' ? Object.assign({}, location, {
        pathname: to
      }) : to,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(FullWidthHighlight, {
        isActive: [lessonId, contentId].includes('software-discovery'),
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Box, {
            marginBlock: "-200",
            marginInlineEnd: "-200",
            children: /*#__PURE__*/_jsx(IconHolder, {
              icon: SprocketIcon,
              size: "800"
            })
          }), /*#__PURE__*/_jsxs(Box, {
            children: [/*#__PURE__*/_jsx(Badge, {
              use: "new",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.tracks.recommendations.optionalSideNav.optionalStep"
              })
            }), /*#__PURE__*/_jsx(Text, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.omniPresent.buttonLabel"
              })
            })]
          })]
        })
      })
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/components/ToolRecommendationOptionalStep.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default ToolRecommendationOptionalStep;